import {
  useEffect, useState
} from 'react';

import {
  SelectedItem, TParentCheckbox
} from './types';

interface UseNestedSelectProps {
  selectedItems: SelectedItem[];
  onApply: (prevSelected: SelectedItem[]) => void;
}

export const useNestedSelect = ({
  selectedItems,
  onApply,
}: UseNestedSelectProps) => {
  const [selectedValue, setSelectedValue] = useState<SelectedItem[]>([]);

  const onClear = () => {
    setSelectedValue([]);
    onApply([]);
  };

  useEffect(
    () => {
      setSelectedValue(selectedItems);
    },
    [selectedItems]
  );

  const onParentCheck = (parentItem: TParentCheckbox) => {
    const {
      id, childrenCheckboxes
    } = parentItem;

    const isSelected = selectedValue.some((item) => item.parentId === id);

    const updatedValue = isSelected
      ? selectedValue.filter((item) => item.parentId !== id)
      : [
        ...selectedValue,
        {
          parentId: id,
          selectedChildrenId:
              childrenCheckboxes?.map((child) => child.id) || [],
        },
      ];

    setSelectedValue(updatedValue);
  };

  const onChildCheck = (parentItem: TParentCheckbox, childId: string) => {
    let updatedValue = [];

    if (!selectedValue.some((item) => item.parentId === parentItem.id)) {
      updatedValue = [
        ...selectedValue,
        {
          parentId: parentItem.id,
          selectedChildrenId:
            parentItem?.childrenCheckboxes
              ?.filter((child) => child.id === childId)
              .map((child) => child.id) || [],
        },
      ];
    } else {
      updatedValue = selectedValue?.map((item) => {
        if (item.parentId !== parentItem.id) {
          return item;
        }

        const isSelected = item.selectedChildrenId.some((id) => childId === id);

        return {
          ...item,
          selectedChildrenId: isSelected
            ? item.selectedChildrenId.filter((id) => childId !== id)
            : [...item.selectedChildrenId, childId],
        };
      });
    }

    setSelectedValue(updatedValue);
  };

  return {
    onChildCheck,
    onParentCheck,
    onClear,
    selectedValue,
    setSelectedValue,
  };
};
